// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = require("!!../node_modules/css-loader/index.js??ref--11-rules-2-oneOf-1!../node_modules/postcss-loader/lib/index.js??postcss!../node_modules/resolve-url-loader/index.js??ref--11-rules-4!../node_modules/sass-loader/lib/loader.js??ref--11-rules-6!./app.scss");
if(typeof content === 'string') content = [[module.id, content, '']];
// Prepare cssTransformation
var transform;

var options = {"singleton":true}
options.transform = transform
// add the styles to the DOM
var update = require("!../node_modules/style-loader/lib/addStyles.js")(content, options);
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(module.hot) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../node_modules/css-loader/index.js??ref--11-rules-2-oneOf-1!../node_modules/postcss-loader/lib/index.js??postcss!../node_modules/resolve-url-loader/index.js??ref--11-rules-4!../node_modules/sass-loader/lib/loader.js??ref--11-rules-6!./app.scss", function() {
			var newContent = require("!!../node_modules/css-loader/index.js??ref--11-rules-2-oneOf-1!../node_modules/postcss-loader/lib/index.js??postcss!../node_modules/resolve-url-loader/index.js??ref--11-rules-4!../node_modules/sass-loader/lib/loader.js??ref--11-rules-6!./app.scss");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}
    if(module.hot) {
      // 1554179577686
      var cssReload = require("!../node_modules/css-hot-loader/hotModuleReplacement.js")(module.id, {"fileMap":"{fileName}"});
      module.hot.dispose(cssReload);
      module.hot.accept(undefined, cssReload);;
    }
  